module.exports = __webpack_public_path__ + "media/application/images/trunk-icon-c4815af1955d43c368fd6c4a0c86e81b.svg";